import React from 'react';
import { Card, CardContent } from './ui/card';
import { Users, Briefcase } from 'lucide-react';

// Zuppin Vehicle Types - Source of Truth
const VEHICLE_TYPES = [
  {
    id: 'VAN',
    name: 'VIP Van',
    image: 'https://res.cloudinary.com/dmu5qh4dj/image/upload/v1774334448/van_zxi1eg.png',
    passengers: 9,
    luggage: 6,
    description: 'Ideal for families',
  },
  {
    id: 'MINI',
    name: 'VIP Mini Bus',
    image: 'https://res.cloudinary.com/dmu5qh4dj/image/upload/v1774334448/mini_r98z8m.png',
    passengers: 16,
    luggage: 13,
    description: 'Perfect for small groups',
  },
  {
    id: 'MIDI',
    name: 'VIP Midi Bus',
    image: 'https://res.cloudinary.com/dmu5qh4dj/image/upload/v1774334447/midi_pgk2do.png',
    passengers: 27,
    luggage: 27,
    description: 'Great for medium groups',
  },
  {
    id: 'BUS',
    name: 'VIP Coach',
    image: 'https://res.cloudinary.com/dmu5qh4dj/image/upload/v1774334447/bus_esh2br.png',
    passengers: 46,
    luggage: 50,
    description: 'Best for large groups',
  },
];

const FleetSection = () => {
  return (
    <section id="fleet" className="py-16 md:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4">
            Our Fleet
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Premium vehicles for every group size
          </p>
        </div>

        {/* Vehicle Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {VEHICLE_TYPES.map((vehicle) => (
            <Card
              key={vehicle.id}
              className="fleet-card bg-card border-0 shadow-lg overflow-hidden group"
            >
              <CardContent className="p-0">
                {/* Vehicle Image */}
                <div className="relative h-40 bg-muted/10 flex items-center justify-center p-4">
                  <img
                    src={vehicle.image}
                    alt={vehicle.name}
                    className="h-full w-auto object-contain transition-transform duration-300 group-hover:scale-105"
                  />
                </div>

                {/* Vehicle Info */}
                <div className="p-5">
                  <h3 className="font-display text-lg font-bold text-card-foreground mb-1">
                    {vehicle.name}
                  </h3>
                  <p className="text-sm text-muted-foreground mb-4">
                    {vehicle.description}
                  </p>

                  {/* Capacity */}
                  <div className="flex items-center gap-4">
                    <div className="flex items-center gap-1.5">
                      <Users className="h-4 w-4 text-primary" />
                      <span className="text-sm font-medium text-card-foreground">
                        {vehicle.passengers}
                      </span>
                    </div>
                    <div className="flex items-center gap-1.5">
                      <Briefcase className="h-4 w-4 text-muted-foreground" />
                      <span className="text-sm font-medium text-card-foreground">
                        {vehicle.luggage}
                      </span>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FleetSection;

// Export vehicle types for use in other components
export { VEHICLE_TYPES };
